"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const r=(e,t)=>e.value.type===t.value.type?0:e.value.type>t.value.type?-1:1,l=(e,t)=>e.label.localeCompare(t.label);exports.sortByName=l;exports.sortByType=r;
